import { useSearchParams, Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { CheckCircle, ArrowRight, Home } from 'lucide-react';

const MESSAGES = {
  sejour: { title: 'Demande de séjour envoyée !', desc: 'Merci pour votre confiance. Notre équipe vous recontactera sous 48 heures pour étudier votre besoin et vous proposer une solution adaptée.' },
  partenaire: { title: 'Candidature enregistrée !', desc: 'Merci pour votre intérêt. Notre équipe partenariats examinera votre dossier et vous recontactera dans les meilleurs délais.' },
  contact: { title: 'Message envoyé !', desc: 'Merci pour votre message. Notre équipe vous répondra dans les plus brefs délais.' },
  default: { title: 'Merci !', desc: 'Votre demande a bien été prise en compte.' }
};

export default function ThankYouPage() {
  const [params] = useSearchParams();
  const type = params.get('type') || 'default';
  const msg = MESSAGES[type] || MESSAGES.default;

  return (
    <div className="min-h-screen flex items-center justify-center py-20 bg-background" data-testid="thank-you-page">
      <div className="max-w-md mx-auto px-4 text-center">
        <div className="w-20 h-20 rounded-full bg-secondary/10 flex items-center justify-center mx-auto mb-6">
          <CheckCircle className="w-10 h-10 text-secondary" />
        </div>
        <h1 className="font-heading text-3xl font-bold text-foreground mb-4">{msg.title}</h1>
        <p className="text-muted-foreground leading-relaxed mb-8">{msg.desc}</p>
        <Link to="/">
          <Button className="rounded-full bg-primary text-primary-foreground px-6 py-5" data-testid="back-home-btn">
            <Home className="mr-2 w-4 h-4" /> Retour à l'accueil
          </Button>
        </Link>
      </div>
    </div>
  );
}
